export enum RouteEnum {
  Home = '',
  Main = '/',
  Categories = '/categories',
  Action1 = '/action-a',
  Action2 = '/action-b',
  Action3 = '/action-c',
  Adjective = '/adjective',
  Clothes = '/clothes',
  Emotions = '/emotion',
  Animal1 = '/animal-a',
  Animal2 = '/animal-b',
  Statistics = '/statistics',
  FinalPage = '/final-page'
}

export enum StatisticsCategory {
  Clicks = 'clicks',
  Correct = 'correct',
  Wrong = 'wrong',
}
